import React from 'react'

function formatNumber(num) {
  if (!num) return '0'
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M'
  if (num >= 1000) return (num / 1000).toFixed(1) + 'K'
  return Math.round(num).toLocaleString()
}

export default function HeatBadge({ score, maxScore, size = 'md' }) {
  const pct = Math.min((score / (maxScore || 1)) * 100, 100)

  const getGradient = () => {
    if (pct > 60) return 'from-orange-500 via-red-500 to-rose-500'
    if (pct > 30) return 'from-amber-500 to-orange-500'
    return 'from-blue-400 to-cyan-500'
  }

  const barWidth = size === 'sm' ? 'w-16' : 'w-24'
  const barHeight = size === 'sm' ? 'h-1' : 'h-1.5'
  const textSize = size === 'sm' ? 'text-[10px]' : 'text-xs'

  return (
    <div className="flex items-center gap-2">
      <div className={`${barHeight} ${barWidth} bg-gray-800 rounded-full overflow-hidden`}>
        <div
          className={`h-full bg-gradient-to-r ${getGradient()} rounded-full transition-all duration-500`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className={`${textSize} font-mono text-gray-400 tabular-nums`}>
        {formatNumber(score)}
      </span>
    </div>
  )
}
